import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedGuard } from '@guards/logged.guard';

const routes: Routes = [
	{
		path: 'auth',
		loadChildren: () => import('@appModules/auth/auth.module').then((m) => m.AuthModule),
	},
	{
		path: 'home',
		canActivate: [LoggedGuard],
		loadChildren: () => import('@appModules/dashboard/dashboard.module').then((m) => m.DashboardModule),
	},
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'home',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
